const privilegeTableSchema = {
    feilds: [{
        id: 1,
        name: 'privilege_name',
        title: 'Privilege',
        visible: false,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text':'S.no', width: "10%" },  { 'id': 2, 'text': 'Privilege Name', width: "20%" }, { 'id': 6, 'text': 'Action', width: "10%" }],
            'table_body': [{
                'id': 1,
                'feilds': [{
                    id: 1,
                    name: 'privilege_name',
                    title: 'Privilege Name',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Select',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Select Privilage'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'privilege_name',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'routine',
                    table: 'privilege_name',
                },]
            }],
            'add_more_feilds': [{
                id: 2,
                name: 'privilege_name',
                title: 'Privilege Name',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Select',
                rules: [{
                    test: (value) => {
                        return (value !== null && value.length > 0 && value != '');
                    },
                    message: 'Select Privilage'
                }],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'privilege_name',
            }, {
                id: 2,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'privilege_name',
            }],
        }
    },]
}
export { privilegeTableSchema };